export default "__VITE_ASSET__0ujlCQnT__"